var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statusvideo"},[_c('div',{staticClass:"status_and_info"},[_c('span',{staticClass:"statusvideo_text",class:_vm.colorstatus},[_vm._v("                \n            "+_vm._s(_vm.textstatus ? _vm.textstatus : _vm.status_name)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }